/**
 * Model to hold a single skill level.
 */
export class SkillLevel {
    public id: string = null;
    public name: string = null;
    public stars: number = null;
    public eventId: string = null;
    public divisionId: string = null;

    constructor(name: string = null, stars: number = null, eventId: string = null, divisionId: string = null) {
        this.name = name;
        this.stars = stars;
        this.eventId = eventId;
        this.divisionId = divisionId;
    }

    public clone(): SkillLevel {
        const clone: SkillLevel = new SkillLevel();
        clone.id = this.id;
        clone.name = this.name;
        clone.stars = this.stars;
        clone.eventId = this.eventId;
        clone.divisionId = this.divisionId;
        return clone;
    }

    /**
     * Serialize from a json api format
     */
    public serialize(): string {
        const json: any = {};
        json.data = {};
        json.data.type = 'skillLevel';
        json.data.id = this.id;
        json.data.attributes = {};
        json.data.attributes.name = this.name;
        json.data.attributes.stars = this.stars;
        return JSON.stringify(json);
    }

    /**
     * Deserialize to a json api format
     */
    public deserialize(json: Object): SkillLevel {
        const data: Object = json['data'] || json;
        const attrs: Object = data['attributes'];

        this.id = data['id'];
        this.name = attrs['name'];
        this.stars = attrs['stars'];
        this.eventId = attrs['eventId'];
        this.divisionId = attrs['divisionId'];

        return this;
    }
}
